<template>
    <b-container class="pt-5">
      <b-row>
        <b-col cols="12" lg="8" class="p-0 ">
          <full-calendar :config="config" :events="events" ref="calendar"  ></full-calendar>

        </b-col>
        <b-col cols="12" lg="4" class="p-0 pl-lg-4 pl-0 pt-4 pt-lg-0" v-if="selectedCalendarDay">
          <div class="fc-calendar-agenda-Title text-dark">
            <h4 class="text-uppercase">Events am {{ getEventDateString}}</h4>
          </div>
          <div v-if="getEventsForSelectedDay">
          <div v-for="(p,i) in getEventsForSelectedDay.products" :key="i">
            <!-- LINK ONLY AVAILABLE -->
            <router-link :to="goToProductDetail(p.id)" v-if="p.state =='Bookable' || p.state =='FewTicketsLeft'">           
              <b-row class="fc-calendar-agenda-Row m-0 p-0 ">
                <b-col cols="3" class="p-2">
                  <div v-html="getAgendaIconWithState(p)"></div>
                </b-col>
                <b-col cols="9" class="pt-5 pt-lg-3 pl-2">
                  <h4 class="text-uppercase">{{p.title}}</h4>
                  <p class="text-muted" v-html="getTimeLabel(p)"></p>                  
                </b-col>
              </b-row>            
            </router-link>

            <div v-else><!-- DONT LINK -->           
              <b-row class="fc-calendar-agenda-Row  m-0 p-0 ">
                <b-col cols="3" class="p-2">
                  <div v-html="getAgendaIconWithState(p)"></div>
                </b-col>
                <b-col cols="9" class="pt-5 pt-lg-3 pl-2">
                  <h4 class="text-uppercase">{{p.title}}</h4> 
                  <p class="text-muted" v-html="getTimeLabel(p)"></p>                  
                </b-col>
              </b-row>
            
            </div>

            
          </div>
        </div>

        </b-col>
      </b-row>

    </b-container>
    
    
</template>

<script>
import { FullCalendar } from 'vue-full-calendar';
import 'fullcalendar/dist/fullcalendar.css';
import moment from 'moment';

export default {
    name: 'ShopCalendar',
    components: {
        FullCalendar,
    },
    data() {
        return{
            events:[],
            selectedCalendarDay: undefined,
            currentFrom: undefined,
            currentTo: undefined,
            config: { // config for calendar
              events: function(start, end,  timezone, callback /**/) {
                //console.log('events', start, end, timezone,callback);
                // get data from server :)
                
                callback( this.loadTicketOverviewFromServer(start.toISOString().slice(0,10),end.toISOString().slice(0,10)) );
              }.bind(this),
                weekends: true,
                themeSystem: 'bootstrap4',   
                locale: 'de',
                defaultView: 'month',
                contentHeight:"auto",
                handleWindowResize:true,   
                fixedWeekCount: false,
                firstDay: 1,   
                editable: false,     
                header: {
                    left:   'prev',
                    center: 'title',
                    right:  'next'
                },
                bootstrapFontAwesome: { 
                  close: 'fa-times',
                  prev: 'fa-angle-left',
                  next: 'fa-angle-right',
                  prevYear: 'fa-angle-double-left',
                  nextYear: 'fa-angle-double-right'
                },
                dayClick: function(date /* , event , view*/) {
                  //console.log(date, event, view)

                  //console.log('Day:', date.format(), this); 
                  
                  this.selectedCalendarDay = date.format();
                  
                }.bind(this),
                eventClick: (calEvent /*, jsEvent, view */) => {
                 // console.log('Event:', calEvent.date, this);
                 
                  this.selectedCalendarDay = calEvent.date;
                },
                eventRender: function(event, element) {
                  //console.log('E: ', event, element);

                  if(event.products != undefined && event.products.length > 0){
                    let inner='<div  class="calendarIconWrapper">';

                    event.products.forEach(p => {
                      // make icon with product state as colors
                      inner += this.getCalendarIconWithState(p);
                    });

                    inner +='</div>'
                    element[0].innerHTML = inner;

                  }else{
                    //nothing on this day
                  }

                }.bind(this)
            },
        }
    },
    methods: {
      goToProductDetail(id){
          return '/app/ticket/' + id+ '/' + this.selectedCalendarDay;
      },
      async loadTicketOverviewFromServer(from='', to=''){
      // what 'FROM' date are we using?  
      if(from == ''){
        //console.log('no FROM overwrite');       
        from = this.currentFrom; 
      }

      // what 'TO' date are we using?  
      if(to == '' && this.currentTo != undefined){
        //console.log('no TO overwrite');
        to = this.currentTo; 
      }

      let config = this.$store.getters.getRestHeaderConfig;
      // prepare Header and Parameters
      config.params = {
          from: from,
          to: to,
        };

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/ticketOverview", config)
        .then(response => {
         // console.log("GET ticketOverview: " , response.status, response.data);
          
          if(response.data.length > 0){
            // add dates to cached product object

            if(response.data.length > 0){
              this.events =  response.data; // this is the data the calendar uses

              let CalendarDays = this.events.filter(function (e) {
                return moment(Date.now()).add(1,'days') > moment(e.date);
              });

              if(CalendarDays != undefined && CalendarDays[CalendarDays.length -1] != undefined){
                this.selectedCalendarDay = CalendarDays[CalendarDays.length -1].date;
              //console.log('Selected Day:', this.selectedCalendarDay);
              }
            }
            
          // console.log("ticketDates found: ", this.getSelectedItem.ticketDates.length , this.getSelectedItem);
          }else{
            //console.log('Found NO tickets!');
          }

          return  response.data;
        })
        .catch(err => {
          console.log("GET ticketDates: ",err);
        });
      },
      eventDayClicked: function(){
       // console.log('--->', this.selectedCalendarDay );

      },
      getTimeLabel(product){
        return 'von <span class="agendaTime">' + product.start.slice(11,16) + '</span> bis <span class="agendaTime">' + product.end.slice(11,16) + '</span> Uhr';
      },
      getCalendarIconWithState(p){
        //NonBookable, Bookable, FewTicketsLeft, SoldOut
        let inner='';
        if(p.state =='Bookable'){
          // add icon and link for each event on that day
          inner += '<div style="cursor: pointer;" class="calendarIcon">';
          inner += '<div class="calendarSVG" title="'+p.title+'">' + p.icon + '</div>'; 
          inner += '</div>';
        }else if(p.state =='FewTicketsLeft'){
          inner += '<div style="cursor: pointer;" class="calendarIcon">';
          inner += '<div class="calendarSVGFewLeft" title="'+p.title+'">' + p.icon + '</div>'; 
          inner += '</div>';
        }else{
          // add icon and no link
          inner += '<div class="calendarIcon">' + '<div class="calendarSVGInactive" title="'+ p.title +'">' + p.icon + '</div>' + '</div>';
        }
        return inner;
      },
      getAgendaIconWithState(p){
        let inner='';
        if(p.state =='Bookable'){
          // add icon and link for each event on that day
          inner += '<div style="cursor: pointer;" class="agendaIcon">';
          inner += '<div class="agendaSVG" title="'+p.title+'">' + p.icon + '</div>'; 
          inner += '</div>';
        }else if(p.state =='FewTicketsLeft'){
          inner += '<div style="cursor: pointer;" class="agendaIcon">';
          inner += '<div class="agendaSVGFewLeft" title="'+p.title+'">' + p.icon + '</div>'; 
          inner += '</div>';
        }else{
          // add icon and no link
          inner += '<div class="agendaIcon">' + '<div class="agendaSVGInactive" title="'+ p.title +'">' + p.icon + '</div>' + '</div>';
        }

        return inner;
      }
  }, 
  computed: {
    getEventsForSelectedDay(){
      //console.log('currentDay', this.selectedCalendarDay);
      let products = [];
      if(this.selectedCalendarDay && this.events.length>0){
      // select day from Overview
        products = this.events.filter((item)=>{
          return Object.keys(item).some((key)=>item[key].includes(this.selectedCalendarDay));
        });
        
        if (products.length > 0) {
          return products[0];
        }
        return undefined;


      }else{
        //console.log('no selectedDay');
        
      }
      return [];
    },
    getEventDateString(){
      return moment(this.selectedCalendarDay).format('DD. MMMM');
    },
    
  },
  beforeMount() {
    moment.locale('de'); // FIXME

    // replace by event method in calendar
    //this.currentFrom = moment().startOf('month').toISOString().slice(0, 10); // format as YYYY-MM-DD
    //this.currentTo = moment().startOf('month').add(6, 'months').toISOString().slice(0, 10); // new Date(new Date().setDate(new Date().getDate() + 31 )).toISOString().slice(0, 10);

    //this.loadTicketOverviewFromServer();
  },
  mounted(){

  }
}
</script>

<style scoped>
.fc-scroller {
  overflow: auto hidden;
}
</style>
